import { useCallback } from 'react';
import { useAlert } from 'components';

import { useGoogleLinkMutation, useGoogleUnlinkMutation } from 'hooks/api/auth';
import { handleMutation } from 'utils/handleMutation';

export const useSocialAccounts = () => {
  const alert = useAlert();

  const [linkGoogle, linkGoogleMutation] = useGoogleLinkMutation();
  const [unlinkGoogle, unlinkGoogleMutation] = useGoogleUnlinkMutation();

  const isUnlinkGoogleLoading = unlinkGoogleMutation.isLoading;

  const onLinkGoogleSuccess = useCallback(() => {
    alert.success('Google account successfully linked');
  }, [alert]);

  const onLinkGoogleError = useCallback(() => {
    alert.error('Google account link error');
  }, [alert]);

  const onUnlinkGoogleSuccess = useCallback(() => {
    alert.success('Google account successfully unlinked');
  }, [alert]);

  const onUnlinkGoogleError = useCallback(() => {
    alert.error('Google account unlink error');
  }, [alert]);

  handleMutation({
    ...linkGoogleMutation,
    onSuccess: onLinkGoogleSuccess,
    onError: onLinkGoogleError,
  });

  handleMutation({
    ...unlinkGoogleMutation,
    onSuccess: onUnlinkGoogleSuccess,
    onError: onUnlinkGoogleError,
  });

  return {
    linkGoogle,
    unlinkGoogle,
    isUnlinkGoogleLoading,
  };
};
